export default "__VITE_ASSET__CpuJ69p5__"